import { render, staticRenderFns } from "./ObloBB.vue?vue&type=template&id=355b3d28&scoped=true&"
import script from "./ObloBB.vue?vue&type=script&lang=js&"
export * from "./ObloBB.vue?vue&type=script&lang=js&"
import style0 from "./ObloBB.vue?vue&type=style&index=0&id=355b3d28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355b3d28",
  null
  
)

export default component.exports